import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-right-icon',
  templateUrl: './chevron-right-icon.component.html',
  styleUrl: './chevron-right-icon.component.scss',
})
export class ChevronRightIconComponent {}
